module.exports = __webpack_public_path__ + "img/smads.4d6dbbc0.png";